<template>
  <header class="mb-auto">
    <div>
      <h3 class="float-md-start mb-0">HOTEL SEARCH</h3>

      <nav
        id="nav"
        class="nav nav-masthead justify-content-center float-md-end"
      >
        <router-link class="nav-link active" to="/">Home</router-link>
        <router-link class="nav-link" to="/search">Search</router-link>
        <router-link class="nav-link" to="/about">About</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style>
</style>